export default __webpack_public_path__ + "static/media/woman-3x4.89275b7b.svg";